// Importation des objets
    import Vue                  from 'vue'
    import Router               from 'vue-router'


// Import des composants
    import Accueil              from '@/components/Accueil'
    import MentionsLegales      from '@/components/Mentions-Legales'

    /* Mairie */
        import Contact                  from '@/components/Contact'
        import EquipeMunicipale         from '@/components/Equipe-municipale'
        import InfosMunicipales         from '@/components/Infos-municipales'
        import ListeDeliberations       from '@/components/Liste-Deliberations'

        
    /* Formalités admin' */
        import CNIPasseport             from '@/components/CNI-Passeport'
        import EtatCivil                from '@/components/Etat-Civil'
        import ListeElectorale          from '@/components/Liste-Electorale'
        import RecensementMilitaire     from '@/components/Recensement-Militaire'

    /* Infos Pratiques */
        import Agenda                   from '@/components/Agenda'
        import ArtisansEntreprises      from '@/components/Artisans-Entreprises'
        import AgriculteurViticulteur   from '@/components/Agriculteur-Viticulteur'
        import AssistantMaternel        from '@/components/Assistant_e_s-maternel_le_s'
        import Association              from '@/components/Association'
        import Bibliotheque             from '@/components/Bibliotheque'
        import Cimetiere                from '@/components/Cimetiere'
        import SalleDesFetes            from '@/components/Salle-des-fetes'
        import CollecteDechet           from '@/components/Collecte-Dechet'
        import NuisanceSonore           from '@/components/Nuisance-Sonore'
        import Transport                from '@/components/Transport'
        import Scolaire                 from '@/components/Scolaire'
        import Environnement            from '@/components/Environnement'
        import AidesFinancieres         from '@/components/Aides-Financieres'

    /* Tourisme */
        import AProposQuenne            from '@/components/A-Propos-Quenne'
        import AiredeJeux               from '@/components/Aire-de-jeux'
        import Monument                 from '@/components/Monument'
        import CheminsRandonnees        from '@/components/Chemins-de-randonnees'
        import CircuitsCycliste         from '@/components/Circuits-cycliste'
        import Histoire                 from '@/components/Histoire'
        import ProdLocales              from '@/components/ProdLocales'

    /* Urbanisme */
        import PLU                      from '@/components/PLU'
        import Urbanisme                from '@/components/Urbanisme'
        import VoirieTravaux            from '@/components/VoirieTravaux'


    /* Quenne */
        import EnImage                  from '@/components/En-image'
        import Publications             from '@/components/Publications'
        import Publication              from '@/components/Publication'

    /* Erreur 404 */
        import NotFound                 from '@/components/Erreur404'


// On précise l'utilisation du routage
Vue.use(Router)


// Définition des routes
export default new Router({
    routes: [
        {path: '/',                                 name: 'Accueil',                      component: Accueil},
        {path: '/mentions-legales',                 name: 'MentionsLegales',              component: MentionsLegales},


        /* Mairie */
            {path: '/contact',                      name: 'Contact',                      component: Contact},
            {path: '/equipe-municipale',            name: 'EquipeMunicipale',             component: EquipeMunicipale},
            {path: '/infos-municipales',            name: 'InfosMunicipales',             component: InfosMunicipales},
            {path: '/liste-deliberations/:id',      name: 'ListeDeliberations',           component: ListeDeliberations},

        /* Formalités admin' */
            {path: '/cni-passeport',                name: 'CNIPasseport',                 component: CNIPasseport},
            {path: '/etat-civil',                   name: 'EtatCivil',                    component: EtatCivil},
            {path: '/liste-electorale',             name: 'ListeElectorale',              component: ListeElectorale},
            {path: '/recensement-militaire',        name: 'RecensementMilitaire',         component: RecensementMilitaire},
        
        /* Infos Pratiques */
            {path: '/agenda',                       name: 'Agenda',                       component: Agenda},
            {path: '/agriculteur-viticulteur',      name: 'AgriculteurViticulteur',       component: AgriculteurViticulteur},
            {path: '/artisans-entreprise',          name: 'ArtisansEntreprises',          component: ArtisansEntreprises},
            {path: '/assistant_e_s-maternel_le_s',  name: 'AssitantMaternel',             component: AssistantMaternel},
            {path: '/associations',                 name: 'Association',                  component: Association},
            {path: '/bibliotheque',                 name: 'Bibliotheque',                 component: Bibliotheque},
            {path: '/collecte-dechet',              name: 'CollecteDechet',               component: CollecteDechet},            
            {path: '/environnement',                name: 'Environnement',                component: Environnement},
            {path: '/nuisance-sonore',              name: 'NuissanceSonore',              component: NuisanceSonore},
            {path: '/salle-des-fetes',              name: 'SalleDesFetes',                component: SalleDesFetes},
            {path: '/transport',                    name: 'Transport',                    component: Transport},
            {path: '/cimetiere',                    name: 'Cimetiere',                    component: Cimetiere},
            {path: '/scolaire',                     name: 'Scolaire',                     component: Scolaire},
            {path: '/aides-financieres',              name: 'AidesFinanciere',              component: AidesFinancieres},

        /* Tourisme */
            {path: '/a-propos-quenne',              name: 'AProposQuenne',                component: AProposQuenne},
            {path: '/aire-de-jeux',                 name: 'AiredeJeux',                   component: AiredeJeux},
            {path: '/monument',                     name: 'Monument',                     component: Monument},
            {path: '/chemins-de-randonnees',        name: 'CheminsRandonnees',            component: CheminsRandonnees},
            {path: '/circuits-a-velo',              name: 'CircuitsCycliste',             component: CircuitsCycliste},
            {path: '/histoire',                     name: 'Histoire',                     component: Histoire},
            {path: '/prod-locales',                 name: 'ProdLocales',                  component: ProdLocales},

        /* Tourisme */
            {path: '/plu',                          name: 'PLU',                          component: PLU},
            {path: '/urbanisme',                    name: 'Urbanisme',                    component: Urbanisme},
            {path: '/voirie-travaux',               name: 'VoirieTravaux',                component: VoirieTravaux},

        /* Quenne */
            {path: '/en-image/:id',                 name: 'EnImage',                      component: EnImage},
            {path: '/publications',                 name: 'Publications',                 component: Publications},
            {path: '/publication/:id',              name: 'Publication',                  component: Publication},

            {path: '/404',                          name: 'NotFound',                     component: NotFound},
            {path: '/:catchAll(.*)',                redirect:'404'}


        ]
})





// WEBPACK FOOTER //
// ./src/router/index.js